export default [
  {
    type: 'STRING',
    name: 'description',
    defaultName: 'Description',
  },
  {
    type: 'STRING',
    name: 'seasons',
    defaultName: 'Seasons',
  },
  {
    type: 'STRING',
    name: 'name',
    defaultName: 'Name',
  },
  {
    type: 'LISTOFSTRINGS',
    name: 'casting',
    defaultName: 'Casting',
  },
  {
    type: 'STRING',
    name: 'titleMediaUrl',
    defaultName: 'Title Media Url',
  },
  {
    type: 'STRING',
    name: 'titleMediaImageUrl',
    defaultName: 'Title Media Image Url',
  },
  {
    type: 'DATETIME',
    name: 'releaseDate',
    defaultName: 'Release Date',
  },
  {
    type: 'STRING',
    name: 'owner',
    defaultName: 'Owner',
  },
  {
    type: 'STRING',
    name: 'id',
    defaultName: 'Id',
  },
  {
    type: 'DATETIME',
    name: 'created',
    defaultName: 'Created',
  },
  {
    type: 'DATETIME',
    name: 'updated',
    defaultName: 'Updated',
  },
  {
    type: 'BOOLEAN',
    name: 'deleted',
    defaultName: 'Deleted',
  },
  {
    type: 'INT',
    name: 'version',
    defaultName: 'Version',
  },
  {
    type: 'STRING',
    name: 'mediaStatus',
    defaultName: 'Media Status',
  },
  {
    type: 'STRING',
    name: 'titleTransparentUrl',
    defaultName: 'Title Transparent Url',
  },
  {
    type: 'STRING',
    name: 'genre',
    defaultName: 'Genre',
  },
  {
    type: 'STRING',
    name: 'tags',
    defaultName: 'Tags',
  },
  {
    type: 'STRING',
    name: 'titleMediaImageLocation',
    defaultName: 'Title Media Image Location',
  },
  {
    type: 'STRING',
    name: 'titleMediaLocation',
    defaultName: 'Title Media Location',
  },
  {
    type: 'STRING',
    name: 'titleTransparentLocation',
    defaultName: 'Title Transparent Location',
  },
  {
    type: 'BOOLEAN',
    name: 'hasProcessed',
    defaultName: 'Has Processed',
  },
  {
    type: 'STRING',
    name: 'rating',
    defaultName: 'Rating',
  },
]
